<template>
  <div>
    <b-row>
      <b-col v-if="domain">
        <b-card>
          <h3>Allgemeine Informationen</h3>
          <b-row >
            <b-col>Domainname</b-col>
            <b-col><p>{{ domain.name }} <span v-if="domain.name !== domain.nameUnicode">({{ domain.nameUnicode }})</span></p></b-col>
          </b-row>
          <b-row >
            <b-col>Benutzer</b-col>
            <b-col><p>{{ domain.username }}</p></b-col>
          </b-row>
          <b-row >
            <b-col>Status</b-col>
            <b-col><p><span :class="{ 'label label-warning': domain.status !== 'ok' && domain.status !== 'active' }">{{ domain.status }}</span></p></b-col>
          </b-row>
          <b-row >
            <b-col>Erstellungsdatum</b-col>
            <b-col><p>{{ domain.create }}</p></b-col>
          </b-row>
          <b-row >
            <b-col>Änderungsdatum</b-col>
            <b-col><p>{{ domain.updated_at }}</p></b-col>
          </b-row>
          <b-row >
            <b-col v-if="domain.delete">Löschung vorgemerkt</b-col>
            <b-col><p>{{ domain.delete }}</p></b-col>
          </b-row>
          <b-row >
            <b-col v-if="domain.suspended_at">Löschdatum</b-col>
            <b-col><p>{{ domain.suspended_at }}</p></b-col>
          </b-row>
          <b-row v-if="domain.suspended_until !== null">
            <b-col>Wiederherstellung bis</b-col>
            <b-col><p>{{ domain.suspended_until }}</p></b-col>
          </b-row>
        </b-card>
        <luma-domain-handles-selection  v-if="!updatePage"
                                        @emit_local_change="emit_local_change"
                                        :name="name"
                                        :config="domain">
        </luma-domain-handles-selection>
        <luma-domain-nameserver-selection @emit_local_change="emit_local_change"
                                          :name="name"
                                          :config="domain"
                                          v-if="!updatePage">
        </luma-domain-nameserver-selection>
        <b-card >
          <h3>Transfer</h3>
          <b-row v-if="!domain.authinfo">
            <b-col >Transferstatus</b-col>
            <b-col>
              <i>nicht erlaubt</i> <br>
              <b-button :disabled='$wait.is("creating-authinfo")'
                        @click="$wait.is('creating-authinfo') || getAuthinfo()">AuthCode anfragen
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="domain.authinfo">
            <b-col >Transferstatus</b-col>
            <b-col>
              <i>erlaubt</i><br>
              AuthCode: {{ domain.authinfo }}<br>
              <b-button variant="primary"
                        :disabled='$wait.is("creating-authinfo")'
                        @click="$wait.is('creating-authinfo') || getAuthinfo()">Neuen AuthCode anfragen
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <h3><i class="fa fa-life-ring fa-gd"></i> Häufige Fragen zu Domains</h3>
          <b-row>
            <b-col>
              Lorem ipsum dolor sit amet
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="!domain.delete && !domain.suspended_at">
          <b-button variant="outline-danger"
                    @click="terminate = !terminate"
                    class="col-12">
            <i class="fa fa-trash fa-gd"></i>
            Domain Kündigung
          </b-button>
          <b-row class="mt-3" v-if="terminate">
            <b-col>
              <b-row>
                <b-col>
                  <b-link @click="terminateNow">Sofort Kündigen</b-link>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col>
                  <b-link @click="terminateDate">Zum Ablaufdatum Kündigen</b-link>
                </b-col>
                <b-col>{{domain.expire}}</b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="domain.delete">
          <b-button v-if="domain"
                    variant="outline-warning"
                    @click="undeleteDomain"
                    class="col-12">
            <i class="fa fa-trash fa-gd"></i>
            Domain Kündigung wiederrufen
          </b-button>
        </b-card>
        <b-card v-if="domain.suspended_at">
          <b-button variant="outline-success"
                    @click="restoreDomain"
                    class="col-12">
            <i class="fa fa-trash fa-gd"></i>
            Domain Wiederherstellen
          </b-button>
        </b-card>
      </b-col>
    </b-row>

<luma-save-changes-button v-if="localChange"
                          :spinner="spinner"
                          @save="save_to_backend()">
</luma-save-changes-button>

  </div>

</template>

<script>
    import axios from "@/store/vue-axios"
    import LumaEmpty from "@/layout/LumaEmpty"
    import Domain from "@/store/models/domain/domain"
    import LumaDomainHandlesSelection from "../setup_domain/luma-domain-handles-selection";
    import LumaDomainNameserverSelection from "../setup_domain/luma-domain-nameserver-selection";
    import LumaSaveChangesButton from "../../layout/luma-save-changes-button";

    export default {
        name: "domain-single-view",
        components: {
            LumaSaveChangesButton,
            LumaDomainNameserverSelection,
            LumaDomainHandlesSelection,
            LumaEmpty
        },
        data: () => ({
            updatePage:false,
            terminate:false,
            localChange:false,
            spinner: false,
            config:{}
        }),

        computed: {
            name() {
                return this.$route.params.name
            },
            domain() {
                return Domain.find(this.name)
                // return Domain.query().with('ownerC|adminC|techC|zoneC|user|nameservers').find(this.name)
            }
        },
        async mounted() {
            Domain.fetch(this.name)
        },
        methods: {
            save_to_backend(){
                this.updatePage = true
                console.log('SAVE_TO_BACKEND:::')
                this.spinner = true
                // SAVE CONFIG UPDATE DOMAIN
                const res = axios.post('/domain/domains/edit',this.config)
                    .then(response=>{
                        Domain.insertOrUpdate({data:response.data.domain})
                        this.spinner = false
                        this.localChange = false
                        this.updatePage= false
                    })
                    .catch(error=>{
                        console.log(error)
                        this.spinner = false
                        this.localChange = false
                        this.updatePage= false
                    })

                // setTimeout(()=>{
                //     this.spinner = false
                //     this.localChange = false
                //     this.updatePage= false
                // },1000)

            },
            emit_local_change(val,edit){
               this.localChange = edit
               this.config = Object.assign({},this.config,val)
            },
            getAuthinfo: async function () {
                this.$wait.start('creating-authinfo')

                await Domain.getAuthinfo(this.name)

                this.$wait.end('creating-authinfo')
            },

            async terminateNow(){
                const del = await axios.delete('/domain/domains/delete', {data:{'domainName': this.domain.name, 'date':null}})
                this.$router.push('/domain/list')
            },
            async terminateDate(){
                const del = await axios.delete('/domain/domains/delete', { data:{'domainName': this.domain.name, 'date': this.domain.expire } })
                this.$router.push('/domain/list')
            },
            async restoreDomain(){
                const x = await axios.post("/domain/domains/restore", {domainName:this.domain.name})
                this.$router.push('/domain/list')
            },
            async undeleteDomain(){
                const x = await axios.post("/domain/domains/undelete", {domainName:this.domain.name})
                this.$router.push('/domain/list')
            },
            async create_config(){
                const x = await JSON.parse(JSON.stringify(this.domain))
                this.config = await Object.assign({},x)
                this.config['domainName'] = this.name
                if (x.nameservers){
                    const keys = Object.keys(x.nameservers).map(el=>{
                          if(!this.config[el]){
                              this.config[el] = x.nameservers[el]
                          }
                        }
                    )
                }
            }
        },
        created() {
            Domain.singleFetch(this.name)
            this.create_config()


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/details_domain/domain-details-view.vue